import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { AudioPlayerProvider } from "./contexts/AudioPlayerContext";
import { Navbar } from "./components/Navbar";
import { AudioPlayer } from "./components/AudioPlayer";

// Pages
import { HomePage } from "./pages/HomePage";
import { MarketplacePage } from "./pages/MarketplacePage";
import { TrackDetailPage } from "./pages/TrackDetailPage";
import { LoginPage } from "./pages/LoginPage";
import { RegisterPage } from "./pages/RegisterPage";
import { DashboardPage } from "./pages/DashboardPage";
import { PurchasesPage } from "./pages/PurchasesPage";
import { ArtistsPage } from "./pages/ArtistsPage";
import { ArtistDetailPage } from "./pages/ArtistDetailPage";
import { AdminPage } from "./pages/AdminPage";
import { PurchaseSuccessPage } from "./pages/PurchaseSuccessPage";
import { InboxPage } from "./pages/InboxPage";

function App() {
  return (
    <AuthProvider>
      <AudioPlayerProvider>
        <div className="App min-h-screen bg-neutral-950">
          <BrowserRouter>
            <Navbar />
            <main className="pb-24">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/marketplace" element={<MarketplacePage />} />
                <Route path="/tracks/:trackId" element={<TrackDetailPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/purchases" element={<PurchasesPage />} />
                <Route path="/artists" element={<ArtistsPage />} />
                <Route path="/artists/:artistId" element={<ArtistDetailPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/purchase/success" element={<PurchaseSuccessPage />} />
                <Route path="/inbox" element={<InboxPage />} />
                <Route path="/inbox/:conversationId" element={<InboxPage />} />
              </Routes>
            </main>
            <AudioPlayer />
          </BrowserRouter>
          <Toaster 
            position="top-right"
            toastOptions={{
              style: {
                background: '#171717',
                color: '#fff',
                border: '1px solid rgba(255,255,255,0.1)',
              },
            }}
          />
        </div>
      </AudioPlayerProvider>
    </AuthProvider>
  );
}

export default App;
